var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11m6.451-4.725a9 9 0 1 0-12.903 0c.078-.59.247-1.294.63-1.846C5.952 14.32 7.074 13.5 8.5 13.5h5c1.427 0 2.549.819 3.32 1.93.385.551.554 1.255.631 1.845m-1.94 1.514q.004-.062.007-.15a8 8 0 0 0-.012-.71c-.039-.607-.157-1.113-.327-1.358-.529-.76-1.106-1.071-1.68-1.071h-5c-.572 0-1.15.312-1.678 1.07-.17.246-.289.751-.328 1.36a8 8 0 0 0-.005.859A8.96 8.96 0 0 0 11 20c1.644 0 3.185-.44 4.512-1.21"
}))));
export default SvgFacebookMobileReelUser;